import { KumpassSearchForm } from './kumpass/KumpassSearchForm'

export const KumpassDetailPage = props => <KumpassSearchForm {...props} />

export default KumpassDetailPage
